<template>
	<div class="about-xhorse" ref="about-employe">
		<div class="title">
			<i class="x-icon-power"></i><span class="x-tit-con">Employee</span>
		</div>
		<div class="content">
			<div class="x-det">
				<ul class="line-one">
					<li class="x-flow" @click="enlargeAboutEme(aboutImage_01_01,{
					    title: 'Colorful Tourism', textArray: [
					     'You can stay in your little corner of the world, or you can experience millions of other ways to live. Join Us! You\'ll have several chances of tourism at home and abroad each year.',
					     'Travel has taught us that getting out into the world can change our life in the best, most unexpected ways. The more you see of the world, the more you’ll realize how it really works.'
					    ]
					})">
						<div class="mark">
							<img :src="aboutImage_01" alt="Xhorse"/>
						</div>
					</li>
					<li class="x-flow" @click="enlargeAboutEme(aboutImage_02_01,{
					    title: 'Oversea Practice', textArray: [
					     'The World is open for our business. We have attended lots of professional exhibitions in various countries such as Germany, the USA, Poland, Argentina, Australia, India, Malaysia, Mexico, Korea, Thailand, Spain, Dubai, and the Czech Republic. In Xhorse, you\'ll have opportunities to go gain rich experience overseas, to show your talents on the world stage, and to enjoy the wonderful scenery of different countries.'
					    ]
					})">
						<div class="mark">
							<img :src="aboutImage_02" alt="Xhorse"/>
						</div>
					</li>
				</ul>
				<ul class="line-sec">
					<li class="x-flow" @click="enlargeAboutEme(aboutImage_03_01,{
					    title: 'Team Building Activity', textArray: [
					     'Team building is one of the most widely used group-development activities in organizations.  We often organize interesting and meaningful activities to better create more happiness. Outdoor team building activities encourage a healthy mindset. When out in nature, you can clear your head and switch off from the rest of your works. While you explore the great outdoors, your mind is free to explore your thoughts. Not always working indoor, we bring you more enjoyment!'
					    ]
					})">
						<div class="mark">
							<img :src="aboutImage_03" alt="Xhorse"/>
						</div>
					</li>
					<li class="x-flow" @click="enlargeAboutEme(aboutImage_04_01,{
					    title: 'Team Building Activity', textArray: [
					     'Every moment passed in Xhorse deserves memorizing. Bid farewell to the old and welcome the new. Let\'s witness every step of Xhorse together at the annual dinner event!'
					    ]
					})">
						<div class="mark" style="left: 0px;">
							<img :src="aboutImage_04" alt="Xhorse"/>
						</div>
					</li>
				</ul>
			</div>
		</div>
		<div class="dialog-area">
			<el-dialog
			:modal="true"
			:destroy-on-close="true"
			:append-to-body="true"
			:lock-scroll="true"
			custom-class="dialog-self"
			:close-on-press-escape="true"
			:visible.sync="dialogVisible"
			width="60%"
			center
			>
				<div slot="" class="el-dialog__header"></div>
				<div class="content">
					<div class="x-close">
						<i class="x-icon-close" @click.passive="dialogClose"></i>
					</div>
					<img :src="currentVisibleImage" alt="Xhorse"/>
					<div class="hit-txt">
						<h3>{{ currentHit.title }}</h3>
						<p v-for="text in currentHit.textArray">{{ text }}</p>
					</div>
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
    import aboutImage_01 from '@/assets/resource/images/home/image_we_06_01.png'
    import aboutImage_02 from '@/assets/resource/images/home/image_we_07_01.png'
    import aboutImage_03 from '@/assets/resource/images/home/image_we_08_01.png'
    import aboutImage_04 from '@/assets/resource/images/home/image_we_09_01.png'

    import aboutImage_01_01 from '@/assets/resource/images/home/image_we_06_02.png'
    import aboutImage_02_01 from '@/assets/resource/images/home/image_we_07_02.png'
    import aboutImage_03_01 from '@/assets/resource/images/home/image_we_08_02.png'
    import aboutImage_04_01 from '@/assets/resource/images/home/image_we_09_02.png'

    export default {
        data(){
            return {
                aboutImage_01: aboutImage_01,
                aboutImage_02: aboutImage_02,
                aboutImage_03: aboutImage_03,
                aboutImage_04: aboutImage_04,

                aboutImage_01_01: aboutImage_01_01,
                aboutImage_02_01: aboutImage_02_01,
                aboutImage_03_01: aboutImage_03_01,
                aboutImage_04_01: aboutImage_04_01,

                dialogVisible: false,
                currentVisibleImage: '',
                currentHit: {
                    title: '',
                    textArray: [],
                }
            };
        },
        methods: {
            enlargeAboutEme(aboutImage, aboutHit) {
                const _this = this;
                console.log(aboutHit)
                _this.currentVisibleImage = aboutImage;
                _this.currentHit = aboutHit;
                _this.dialogVisible = true;
            },
            dialogClose(){
                const _this = this;
                _this.currentVisibleImage = '';
                _this.currentHit = '';
                _this.dialogVisible = false;
            }
        }

    }

</script>

<style scoped>

	.about-xhorse {
		background: #FFFFFF;
		min-width: 61.5rem;
		height: 41.75rem;
		padding-bottom: .75rem;
		border-bottom: .75rem solid #F7F8F8;
		overflow: hidden;
	}

	.hit-txt > h3 {
		width: calc(100% - 13.5rem);
		height: 43px;
		margin-top: 2.6875rem;
		font-family: "Open SB";
		font-size: 2rem;
		color: #3B3A38;
		margin: 0 auto;
		padding-top: 1.5rem;
	}

	.hit-txt > p {
		margin: 0 auto;
		width: calc(100% - 13.5rem);
		font-size: 1rem;
		color: #515555;
		letter-spacing: 0;
		text-align: justify;
		line-height: 1.5rem;
	}

	.hit-txt > p {
		margin-top: 1.5rem;
	}

	.content > .hit-txt {
		width: 100%;
		height: 15.625rem;
		background-color: #FFFFFF;
		border: none;
	}

	.content > .x-close {
		margin: 0 auto;
		width: 100%;
		height: 2.5rem;
		position: absolute;
		right: 0;
		text-align: right;
	}

	.content > img {
		width: 100%;
	}

	.x-icon-close {
		display: block;
		width: 2.125rem;
		height: 2.125rem;
		content: url("../../../assets/resource/icons/ico_home_close.png");
		position: absolute;
		right: 1.5625rem;
		top: 1.5625rem;
	}

	.about-xhorse > .title {
		min-width: 61.5rem;
		margin-left: 3.25rem;
		text-align: left;
		padding-top: 2.75rem;
		padding-bottom: 2.75rem;
		line-height: 2.75rem;
	}

	.about-xhorse > .content {
		width: 54.5rem;
		margin-left: 7rem;
	}

	.title > .x-icon-power {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_we_extreme.png");
		width: 2.75rem;
		height: 2.75rem;
		position: relative;
		top: .625rem;
		margin-right: 1rem;
	}

	.title > .x-tit-con {
		display: inline-block;
		width: calc(100% - 3.75rem);
		height: 2.75rem;
		font-family: Open Sans;
		font-size: 1.5rem;
		color: #3B3A38;
	}

	.content > .x-det {
		width: 54.5rem;
		min-height: 26.5rem;
		/*margin-left: 2.75rem;*/
	}

	.x-det > ul {
		width: 100%;
		height: 13.25rem;
	}

	.x-det > ul > li > img {
		width: 100%;
	}

	.x-det > ul > li {
		height: 13.25rem;
		border: none;
		cursor: pointer;
	}

	.line-one > li:nth-child(1) {
		width: 23.5rem;
		opacity: 0.8;
		/*background: #DE452E;*/
	}

	.line-one > li:nth-child(2) {
		width: calc(100% - 23.5rem);
		opacity: 0.8;
		/*background: #3277D1;*/
	}

	.line-sec > li:nth-child(1) {
		width: calc(100% - 23.5rem);
		opacity: 0.8;
		/*background: #88B14B;*/
	}

	.line-sec > li:nth-child(2) {
		width: 23.5rem;
		opacity: 0.8;
		/*background: #F5A623;*/
		/*margin-left: 32px;*/
	}

	.mark {
		width: 100%;
		height: 100%;
		border: none;
		font-family: DINCondensed-Bold;
		font-size: 2rem;
		color: #FFFFFF;
		letter-spacing: 0;
		line-height: 4rem;
		position: relative;
		text-align: left;
	}

	.mark > img {
		width: 100%;
		height: 100%;
		border: none;
	}

</style>



// WEBPACK FOOTER //
// src/components/zh-cn/about/about-employe.vue